import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineShieldCheck, HiOutlineUserGroup, HiOutlineSparkles, HiOutlineHome, HiOutlineLockClosed, HiOutlineExclamationCircle } from 'react-icons/hi';

function SafetyCenter() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    const safetyFeatures = [
        {
            icon: <HiOutlineUserGroup size={24} />,
            title: "Trusted Professionals",
            desc: "Every AstraClean specialist undergoes rigorous background verification and safety training to ensure a secure environment."
        },
        {
            icon: <HiOutlineSparkles size={24} />,
            title: "Safe Products",
            desc: "We prioritize eco-friendly and non-toxic cleaning agents that are safe for your children, pets, and the planet."
        },
        {
            icon: <HiOutlineHome size={24} />,
            title: "Space Respect",
            desc: "Our team follows precise protocols to handle your belongings and furniture with the maximum possible care."
        },
        {
            icon: <HiOutlineLockClosed size={24} />,
            title: "Privacy First",
            desc: "Your data and home privacy are sacred. We implement top-tier confidentiality measures for every single booking."
        }
    ];

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            {/* Safety Hero */}
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden">
                <div className="container-custom relative z-10 text-center max-w-3xl mx-auto px-4">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">AstraClean Shield</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        Safety is our <span className="text-primary italic">Priority</span>
                    </h1>
                    <p className="text-muted-foreground text-lg mt-6 leading-relaxed">
                        We go beyond simple cleaning to provide a secure, healthy, and trustworthy experience for every household and business we serve.
                    </p>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="grid md:grid-cols-2 gap-8 mb-20">
                        {safetyFeatures.map((feature, i) => (
                            <div key={i} className="card-premium p-10 flex gap-8 items-start group hover:bg-black hover:text-white transition-all duration-500">
                                <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center shrink-0 group-hover:bg-primary group-hover:text-white transition-colors">
                                    {feature.icon}
                                </div>
                                <div className="space-y-3">
                                    <h3 className="text-xl font-bold">{feature.title}</h3>
                                    <p className="text-muted-foreground text-sm font-medium leading-relaxed group-hover:text-gray-400">
                                        {feature.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Reporting Bar */}
                    <div className="p-8 md:p-12 rounded-[2.5rem] bg-secondary border border-border flex flex-col md:flex-row items-center justify-between gap-8">
                        <div className="flex items-center gap-6 text-center md:text-left">
                            <div className="w-12 h-12 rounded-full bg-red-50 text-red-500 flex items-center justify-center shrink-0 hidden md:flex">
                                <HiOutlineExclamationCircle size={28} />
                            </div>
                            <div className="space-y-1">
                                <h4 className="font-bold text-lg">Report a Safety Concern</h4>
                                <p className="text-sm text-muted-foreground font-medium">Notice something unusual? Inform our response team immediately.</p>
                            </div>
                        </div>
                        <button className="px-10 py-4 rounded-xl bg-white border border-border text-xs font-black uppercase tracking-[0.2em] hover:bg-red-500 hover:text-white hover:border-red-500 transition-all shadow-sm">
                            Inform Support
                        </button>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default SafetyCenter;

